import './Upload.css'
import Upload from './Upload'
export default Upload